import React from 'react'
import FolderIcon from "@material-ui/icons/Folder";
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconFolderButton(
    {
        ...props
    }) {
    return <WorkableIconButton
        Icon={FolderIcon}
        {...props}
    />
}

WorkableIconFolderButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconFolderButton;